import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["viewBox"]
const _hoisted_2 = ["xlink:href"]
const _hoisted_3 = ["x", "y", "onMouseover"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["d"]
const _hoisted_6 = ["d"]
const _hoisted_7 = ["transform"]
const _hoisted_8 = {
  class: "house-marker-bg",
  transform: "translate(-3.87 -3.87) scale(1.3225)"
}
const _hoisted_9 = ["fill"]
const _hoisted_10 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tippy = _resolveDirective("tippy")!

  return ($props.map)
    ? (_openBlock(), _createElementBlock("svg", {
        key: 0,
        class: "svg-map-scale",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        viewBox: `0 0 ${$setup.props.map.size.width} ${$setup.props.map.size.height}`,
        style: _normalizeStyle({ transform: 'scale(' + $setup.props.zoom + ')' })
      }, [
        _createElementVNode("image", {
          "xlink:href": $setup.props.map.mapImage.url
        }, null, 8, _hoisted_2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.lots, (lot) => {
          return (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(["item-wr", $setup.props.getItemWrClasses(lot)]),
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            version: "1.1",
            x: lot.binding.x,
            y: lot.binding.y,
            onMouseover: ($event: any) => ($setup.onLotHover(lot?.lotId?._id)),
            onMouseleave: $setup.onLotLeave
          }, [
            _withDirectives((_openBlock(), _createElementBlock("g", {
              class: "scale",
              tabindex: "-1",
              focusable: "false",
              onClick: ($event: any) => ($setup.onLotClick(lot)),
              onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createElementVNode("path", {
                class: _normalizeClass(["item-path", $setup.props.getItemPathClasses(lot)]),
                d: lot.path,
                tabindex: "-1",
                focusable: "false"
              }, null, 10, _hoisted_5),
              _createElementVNode("path", {
                class: _normalizeClass(["item-status-path", $setup.props.getItemStatusPathClasses(lot)]),
                d: lot.statusPath
              }, null, 10, _hoisted_6),
              ($setup.shouldShowHouseMarker(lot))
                ? (_openBlock(), _createElementBlock("g", {
                    key: 0,
                    class: "house-marker",
                    transform: $setup.getHouseMarkerTransform(lot)
                  }, [
                    _createElementVNode("g", _hoisted_8, [
                      _createElementVNode("path", {
                        class: "house-marker-color-a",
                        d: "M6.6 2.65A10.8 10.8 0 0 0 17.4 21.35Z",
                        fill: $setup.getHouseMarkerColors(lot).color
                      }, null, 8, _hoisted_9),
                      _createElementVNode("path", {
                        class: "house-marker-color-b",
                        d: "M6.6 2.65A10.8 10.8 0 0 1 17.4 21.35Z",
                        fill: $setup.getHouseMarkerColors(lot).colorB
                      }, null, 8, _hoisted_10),
                      _cache[1] || (_cache[1] = _createElementVNode("circle", {
                        class: "house-marker-outline",
                        cx: "12",
                        cy: "12",
                        r: "10.8"
                      }, null, -1))
                    ]),
                    _cache[2] || (_cache[2] = _createElementVNode("g", {
                      class: "house-marker-icon",
                      transform: "translate(3 3) scale(0.75)"
                    }, [
                      _createElementVNode("path", {
                        class: "house-marker-house",
                        d: "m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
                      }),
                      _createElementVNode("polyline", {
                        class: "house-marker-house",
                        points: "9 22 9 12 15 12 15 22"
                      })
                    ], -1))
                  ], 8, _hoisted_7))
                : _createCommentVNode("", true)
            ], 40, _hoisted_4)), [
              [_directive_tippy, { content: $setup.props.getTooltipText(lot), allowHTML: 'true', theme: 'map-tippy', appendtTo: 'element', arrow: false }]
            ])
          ], 42, _hoisted_3))
        }), 256))
      ], 12, _hoisted_1))
    : _createCommentVNode("", true)
}